import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as PIXI from 'pixi.js';
import image3 from '../../assets/backgroundImages/map.png';
import { setPixiActiveObject, setPixiCanvasAsImage,setObject } from "../../Store/reducers/pixiCanvasSlice.js";
import {
    createBoundingBox,
    createDisplacementSprite,
    createResizeControls,
    createTextSprite,
    updateBoundingBox,
    updateControlPositionsForControls
} from "./customBoundingBox.jsx";
import controlsHelper from "./controlsHelper.jsx";
import { clampSpriteScale } from '../../utils/pixiHelper.js';
import { createResizer } from "./resizeHelper.jsx";
import { convertFabricCanvasToPNGDataURL, convertSVGToPNGDataURL } from "../../utils/fabricHelper.js";
import { saveState } from '../../Store/reducers/fabriccontrolsSlice.js';
import { useLocation } from "react-router-dom";
import { setCanvasLoaded } from '../../Store/reducers/waitTextureSlice.js';

const DisplacementEffect = () => {
    const dispatch = useDispatch();
    const canvas = useSelector((state) => state.canvas.app);
    const canvasesState = useSelector((state) => state.canvasesstate.canvases);
    const dimensions = useSelector((state) => state.canvas.dimensions);
    const maskSprite = useSelector((state) => state.canvas.maskSprite);
       const  zoom  = useSelector((state) => state.canvasesstate.zoom);
       const currentState = canvasesState.previewMockupCanvasState?.currentState;

    const { svgDetails } = useSelector((state) => state.svgDetails);
    const selectedMockup = useSelector((state) => state.mockupCategories.selectedMockup) || [];

    // Get productId from query parameters.
    const location = useLocation();
    const productId = useMemo(
        () => new URLSearchParams(location.search).get('product_id'),
        [location.search]
    );

    // State for saved canvas state and SVG image.
    // const [savedState, setSavedState] = useState(() => {
    //     // const local = localStorage.getItem(`pixiCanvasState_${productId}`);
    //     const local = canvasesState.previewMockupCanvasState?.currentState;
    //     return local ? JSON.parse(local) : null;
    // });
    // const editedSVG = localStorage.getItem(`editSVGCanvasState_${productId}`);
    const editedSVG = canvasesState.editSVGCanvasState?.currentState;
   

    const [svgImage, setSvgImage] = useState(null);
    const [initialScale, setInitialScale] = useState(0.5);

    // Refs for PIXI objects.
    const textDesignRef = useRef(null);
    const boundingBoxRef = useRef(null);
    const controlsRef = useRef({});

    useEffect(() => {
        function hideAllControls() {
          if (boundingBoxRef.current) {
            boundingBoxRef.current.visible = false;
          }
          Object.values(controlsRef.current).forEach(ctrl => {
            if (ctrl && typeof ctrl.visible === "boolean") {
              ctrl.visible = false;
            }
          });
        }
    
        window.addEventListener("pixiControlsHide", hideAllControls);
        return () => {
          window.removeEventListener("pixiControlsHide", hideAllControls);
        };
      }, []);


    // --- 1. Load SVG Image or Fabric Canvas Image ---
    const loadCanvasImage = useCallback(async () => {
        if (editedSVG) {
            setInitialScale(0.5);
            const canvasData = JSON.parse(editedSVG); 
            try {
                const pngDataURL = await convertFabricCanvasToPNGDataURL(canvasData);
              
                setSvgImage(pngDataURL);
            } catch (error) {
                console.error("Error converting fabric canvas:", error);
            }
        } else {
            setInitialScale(0.5);
            const files = svgDetails?.data?.downloadable_files;
            if (files) {
                const key = Object.keys(files)[0];
                convertSVGToPNGDataURL(svgDetails.data.downloadable_files[key]?.file)
                    .then((pngDataURL) => {
                        setSvgImage(pngDataURL);
                    });
            }
        }
    }, [currentState, svgDetails, editedSVG]);
    

    useEffect(() => {
        console.log("SVG Image: ", svgImage);
        loadCanvasImage();
    }, [loadCanvasImage]);

    // --- 2. Create a PIXI Texture from the SVG Image ---
    const svgTexture = useMemo(() => {
        if (!svgImage) return null;
        try {
            console.log("SVGIMAGEEEE", svgImage)
            return PIXI.Texture.from(svgImage, {
                resolution: window.devicePixelRatio > 1 ? window.devicePixelRatio : 2,
                resourceOptions: { crossOrigin: 'anonymous' },
                scaleMode: PIXI.SCALE_MODES.LINEAR,
                
            });
        } catch (error) {
            console.error("Failed to create texture:", error);
            return null;
        }
    }, [svgImage]);

    // --- 3. Update the Canvas DataURL ---
    // const updateCanvasDataURL = useCallback(() => {
    //     if (!canvas || !svgTexture) return;
    //     console.log("updateCanvasDataURL:")
    //     try {
    //         if (boundingBoxRef.current) boundingBoxRef.current.visible = false;
    //         Object.values(controlsRef.current).forEach(control => control.visible = false);
    //         canvas.renderer.render(canvas.stage);
    //         const dataURL = canvas.renderer.extract.canvas(canvas.stage).toDataURL('image/png', 1.0);
    //         if (boundingBoxRef.current) boundingBoxRef.current.visible = true;
    //         Object.values(controlsRef.current).forEach(control => control.visible = true);
    //         dispatch(setPixiCanvasAsImage(dataURL));
    //     } catch (error) {
    //         console.error("Failed to get canvas DataURL:", error);
    //     }
 

    const updateCanvasDataURL = useCallback(() => {
        if (!canvas || !svgTexture) return;
        try {
            if (boundingBoxRef.current) boundingBoxRef.current.visible = false;
            Object.values(controlsRef.current).forEach(control => control.visible = false);
            
    
            // Ensure renderer size is accurate
            const width = canvas.renderer.screen.width;
            const height = canvas.renderer.screen.height;
    
            const background = new PIXI.Graphics();
            background.beginFill(0xFFFFFF); // white
            background.drawRect(0, 0, width, height);
            background.endFill();
    
            canvas.stage.addChildAt(background, 0);
            canvas.renderer.render(canvas.stage);
                const dataURL = canvas.renderer.extract.canvas(canvas.stage).toDataURL('image/png', 1.0);
    
                canvas.stage.removeChild(background);
                if (boundingBoxRef.current) boundingBoxRef.current.visible = true;
                Object.values(controlsRef.current).forEach(control => control.visible = true);
    
                dispatch(setPixiCanvasAsImage(dataURL));
                dispatch(setCanvasLoaded(true))
        } catch (error) {
            console.error("Failed to get canvas DataURL:", error);
            dispatch(setCanvasLoaded(false))
        }

    }, [canvas, svgTexture, dispatch, selectedMockup]);


    // --- 4. Save the Canvas State ---
    const saveCanvasState = useCallback(() => {
        const textDesign = textDesignRef.current;
        if (!textDesign) return;
        const stateToSave = {
            textDesign: {
                x: textDesign.x,
                y: textDesign.y,
                width: textDesign.width,
                height: textDesign.height,
                rotation: textDesign.rotation,
                scaleX: textDesign.scale.x,
                scaleY: textDesign.scale.y,
                wrapping: textDesign.filters?.[0]?.scale?.y
            },
            svgImage
        };

        // const key = productId || 'default';
        // localStorage.setItem(`pixiCanvasState_${key}`, JSON.stringify(stateToSave));

         dispatch(saveState({  tab:"previewMockupCanvasState", canvasState: JSON.stringify(stateToSave ) }));

        // setSavedState(stateToSave);
    }, [svgImage, productId]);

    const waitForTexture = (texture) =>
        new Promise((resolve) => {
          if (texture.baseTexture.valid) {
            resolve();
          } else {
            texture.baseTexture.once('loaded', resolve);
          }
        });
      
      // --- Helper: Wait for a few animation frames ---
      const waitForFrames = (frameCount = 5) => {
        return new Promise((resolve) => {
          let count = 0;
          const step = () => {
            count++;
            if (count >= frameCount) {
              resolve();
            } else {
              requestAnimationFrame(step);
            }
          };
          requestAnimationFrame(step);
        });
      };


  

    
  
    // --- 5. Initialize the PIXI Displacement Effect ---
    const initializeEffect = useCallback(() => {
        if (!canvas || !svgTexture || !canvas.stage) return;
        
        canvas.stage.interactive = true;

        Promise.all([
            waitForTexture(svgTexture),
           
            waitForTexture(PIXI.Texture.from(selectedMockup.glb_layer || image3)),
            waitForTexture(PIXI.Texture.from(selectedMockup.design_layer || image3))

          ]).then(async () => {
            await waitForFrames(4); 
            updateCanvasDataURL();

          });

        // requestAnimationFrame(() => updateCanvasDataURL());

        const cameraContainer = canvas.cameraContainer;
        const displacementTexture = PIXI.Texture.from(selectedMockup.glb_layer || image3);

        const textTexture = svgTexture;
     
        textTexture.baseTexture.mipmap = PIXI.MIPMAP_MODES.ON;
        // Create the text sprite.
        const textDesign = createTextSprite(textTexture, currentState, dimensions, zoom, initialScale,canvas, {
            boundaryX1: selectedMockup.logoBoundaryX1,
            boundaryX2: selectedMockup.logoBoundaryX2,
            boundaryY1: selectedMockup.logoBoundaryY1,
            boundaryY2: selectedMockup.logoBoundaryY2,
            defaultSize: selectedMockup.logoDefaultSize,
            minSize: selectedMockup.logoMinSize,
            maxSize: selectedMockup.logoMaxSize,
            BASE_WIDTH:selectedMockup?.width,
            BASE_HEIGHT: selectedMockup?.height
        });
        textDesignRef.current = textDesign;
        canvas.__textDesign = textDesign;
        textDesign.roundPixels = false;
        textDesign.minSize = selectedMockup.logoMinSize || 50;
        textDesign.maxSize = selectedMockup.logoMaxSize || Infinity;

         saveCanvasState();
        dispatch(setObject(textDesign))

        clampSpriteScale(
            textDesign,
            selectedMockup.logoMinSize || 50,
            selectedMockup.logoMaxSize || 1000,
            selectedMockup.logoDefaultSize || 100
          );
        

        // Create a container for the text design and apply the mask.
        const textContainer = new PIXI.Container();
        textContainer.addChild(textDesign);
        textContainer.mask = maskSprite;
        textContainer.isDisplacementDesign = true;
        cameraContainer.addChild(textContainer);

        // Create displacement sprite and apply filter.
        const displacementSprite = createDisplacementSprite(displacementTexture, dimensions, canvas);
        const displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
        textDesign.filters = [displacementFilter];

        
        if (currentState?.wrapping) {
            displacementFilter.scale.set(currentState.wrapping, currentState.wrapping);
            
        } else {
            displacementFilter.scale.set(15/2, 15/2);
           
        }
        
        const resizer = createResizer();

        // --- Create Hover Bounding Box ---
        const hoverBoundingBox = createBoundingBox(textDesign);
        hoverBoundingBox.visible = false;
        cameraContainer.addChild(hoverBoundingBox);

        // --- Pointer Events for textDesign ---
        // Consolidated pointer events takay duplicate registrations na ho aur drag smooth ho.
        textDesign.interactive = true;
        textDesign.buttonMode = true;

        textDesign.on('pointerdown', (event) => {
            // Activate the object.
            dispatch(setPixiActiveObject(textDesign));
            textDesign.isActive = true;
            hoverBoundingBox.visible = false;
            event.stopPropagation();
            textDesign.data = event.data;
            const pointerPos = event.data.getLocalPosition(textDesign.parent);
            textDesign.dragOffset = {
                x: pointerPos.x - textDesign.position.x,
                y: pointerPos.y - textDesign.position.y,
            };
            textDesign.dragging = true;
            // textDesign.alpha = 0.8; 
            requestAnimationFrame(() => saveCanvasState());
            saveCanvasState();
            // updateCanvasDataURL();
        });

        // const stagePointerMove = (event) => {
        //     if (textDesign.dragging && !resizer.isResizing()) {
        //       const newPos = event.data.getLocalPosition(textDesign.parent);
        //       textDesign.position.set(
        //         newPos.x - textDesign.dragOffset.x,
        //         newPos.y - textDesign.dragOffset.y
        //       );
        //       updateControlPositions();
        //     }
        //   };


          const stagePointerMove = (event) => {
            if (!textDesign.dragging || resizer.isResizing()) return;
          
            // take the global point and convert it into the sprite’s parent coordinate space
            const globalPoint = event.data.global;
            const coordSpace  = textDesign.parent || canvas.stage;
            const localPoint  = coordSpace.toLocal(globalPoint);
          
            textDesign.position.set(
              localPoint.x - textDesign.dragOffset.x,
              localPoint.y - textDesign.dragOffset.y
            );
            updateControlPositions();
          };

        
          const stagePointerUp = (event) => {
            if (textDesign.dragging) {
              textDesign.dragging = false;
              textDesign.data = null;
              
              saveCanvasState();
              updateCanvasDataURL();
            }
          };
        
          canvas.stage.on('pointermove', stagePointerMove);
          canvas.stage.on('pointerup', stagePointerUp);
          canvas.stage.on('pointerupoutside', stagePointerUp);

      
          const hoverTopPadding = 10;

          // --- Hover effects ---
          textDesign.on("mouseover", () => {
            if (!textDesign.isActive) {
              const w = textDesign.width;
              const h = textDesign.height;
          
              hoverBoundingBox.clear();
              hoverBoundingBox.lineStyle(2, 0x000000, 1);
              hoverBoundingBox.drawRect(
                -w / 2,
                -h / 2 - hoverTopPadding, // move box up by padding
                w,
                h + hoverTopPadding * 2       // extend box height to keep bottom same
              );
              hoverBoundingBox.x = textDesign.x;
              hoverBoundingBox.y = textDesign.y;
              hoverBoundingBox.rotation = textDesign.rotation;
              hoverBoundingBox.visible = true;
            }
          });
          

        textDesign.on("mouseout", () => {
            hoverBoundingBox.visible = false;
        });

        // --- Stage Click: Deselect when clicking outside ---
        const stagePointerDown = (event) => {
          
            const { x, y } = event.data.global;
            if (
              textDesign &&
              hoverBoundingBox &&
              !textDesign.containsPoint(new PIXI.Point(x, y)) &&
              !controlsHelper.isControlActive({ x, y }, controlsRef.current)
            ) {
              dispatch(setPixiActiveObject(null));
              textDesign.isActive = false;
              hoverBoundingBox.visible = false;
            //   event.stopPropagation();
            //   const pointerPos = event.data.getLocalPosition(textDesign.parent);
            //   textDesign.dragOffset = {
            //     x: pointerPos.x - textDesign.position.x,
            //     y: pointerPos.y - textDesign.position.y,
            //   };
              removeBoundingBoxAndControls();
              saveCanvasState();
              updateCanvasDataURL();
            }
          };
          canvas.stage.on('pointerdown', stagePointerDown);
          

        // --- Helper: Update Bounding Box & Control Positions ---
        const updateControlPositions = () => {
            if (!boundingBoxRef.current) return;
            const { width, height, x, y, rotation } = textDesign;
            console.log("updated properties",width,)
            const verticalPadding = 10;
            const newWidth = width ;
            const newHeight = height + verticalPadding * 2;
            const newY = y ; 
            updateBoundingBox(boundingBoxRef.current, newWidth, newHeight, x, newY, rotation);
            updateControlPositionsForControls(controlsRef.current, newWidth, newHeight, x, newY, rotation);
        };

        // --- Helper: Create Bounding Box & Resize Controls ---
        const createBoundingBoxAndControls = () => {
            if (boundingBoxRef.current) return;
            const bbox = createBoundingBox(textDesign);
            cameraContainer.addChild(bbox);
            boundingBoxRef.current = bbox;
            const newControls = createResizeControls();
            Object.values(newControls).forEach(control => cameraContainer.addChild(control));
            controlsRef.current = newControls;
        };

        // --- Helper: Remove Bounding Box & Controls ---
        const removeBoundingBoxAndControls = () => {
            if (boundingBoxRef.current) {
                cameraContainer.removeChild(boundingBoxRef.current);
                Object.values(controlsRef.current).forEach(control => cameraContainer.removeChild(control));
                dispatch(setPixiActiveObject(null));
                boundingBoxRef.current = null;
                controlsRef.current = {};
            }
        };

        // --- Canvas View Event Listeners for Resize and Cursor ---
        const handleMouseDown = (e) => {
            const rect = canvas.view.getBoundingClientRect();
            const pos = { x: e.clientX - rect.left, y: e.clientY - rect.top };
            const isClicked = textDesign.containsPoint(new PIXI.Point(pos.x, pos.y));
            const controlName = controlsHelper.getControlAtPosition(pos, controlsRef.current);
            if (isClicked || controlName) {
                createBoundingBoxAndControls();
                updateControlPositions();
                if (controlName) resizer.startResize(controlName, pos, textDesign);
            }
        };

        const handleMouseMove = (e) => {
            const rect = canvas.view.getBoundingClientRect();
            const pos = { x: e.clientX - rect.left, y: e.clientY - rect.top };
            if (resizer.isResizing()) {
                resizer.updateResize(pos, textDesign, updateControlPositions);
            }
        };

        const handleMouseUp = () => {
            if (resizer.isResizing()) {
                const newPos = resizer.endResize(textDesign);
                if (newPos) {
                    saveCanvasState();
                    updateCanvasDataURL();
                }
            }
        };

        const updateCursorStyle = (e) => {
            const rect = canvas.view.getBoundingClientRect();
            const pos = { x: e.clientX - rect.left, y: e.clientY - rect.top };
            const controlName = controlsHelper.getControlAtPosition(pos, controlsRef.current);
            if (controlName) {
                canvas.view.style.cursor = controlName === "rotate" ? 'crosshair' : controlsHelper.getCornerCursor(controlName, textDesign.rotation);
            } else if (textDesign.getBounds().contains(pos.x, pos.y)) {
                canvas.view.style.cursor = 'move';
            } else {
                canvas.view.style.cursor = 'default';
            }
        };
      

        canvas.view.addEventListener('mousedown', handleMouseDown);
        canvas.view.addEventListener('mousemove', updateCursorStyle);
        canvas.view.addEventListener('mousemove', handleMouseMove);
        canvas.view.addEventListener('mouseup', handleMouseUp);
        canvas.view.addEventListener('mouseleave', handleMouseUp);
        


        // --- Cleanup ---
        return () => {
           
            canvas.view?.removeEventListener('mousedown', handleMouseDown);
            canvas.view?.removeEventListener('mousemove', updateCursorStyle);
            canvas.view?.removeEventListener('mousemove', handleMouseMove);
            canvas.view?.removeEventListener('mouseup', handleMouseUp);
            canvas.view?.removeEventListener('mouseleave', handleMouseUp);

            
         
            cameraContainer?.removeChild(displacementSprite);
            cameraContainer?.removeChild(textDesign);
            if (textDesignRef.current && textDesignRef.current.parent) {
                textDesignRef.current.parent.removeChild(textDesignRef.current);
            }
            textDesignRef.current = null;
          
            removeBoundingBoxAndControls();
        };
        
    }, [
        canvas,
        svgTexture,
        dimensions,
        initialScale,
        currentState,
        saveCanvasState,
        selectedMockup,
    ]);

    // --- 6. Effect to Initialize/Update the PIXI Displacement Effect ---
    useEffect(() => {
        if (!svgImage || !canvas || !svgTexture || !canvas.stage) return;
    
       
        const cleanupOld = () => {
            if (boundingBoxRef.current) {
                canvas.cameraContainer.removeChild(boundingBoxRef.current);
                boundingBoxRef.current = null;
            }
            Object.values(controlsRef.current).forEach(control => {
                canvas.cameraContainer.removeChild(control);
            });
            controlsRef.current = {};
            dispatch(setPixiActiveObject(null));
            
        };
    
      
        cleanupOld();
    
        if (!svgTexture.baseTexture.valid) {
            const handleLoaded = () => initializeEffect();
            svgTexture.baseTexture.on('loaded', handleLoaded);
            return () => {
                svgTexture.baseTexture.off('loaded', handleLoaded);
            };
        } else {
            const cleanup = initializeEffect();
            return () => {
             
                cleanup && cleanup();
                cleanupOld();
            };
        }
    }, [svgImage, canvas, svgTexture, zoom, selectedMockup]);
    
    return null;
};

export default DisplacementEffect;
